import { serviceAreas } from "../data/service-areas.js";

function renderServiceAreaRegions(container) {
  const cards = serviceAreas.map((area) => {
    const card = document.createElement("article");
    card.className = "area-region";
    card.dataset.serviceAreaId = area.id;

    const heading = document.createElement("h3");
    heading.textContent = area.label;

    const list = document.createElement("ul");
    list.className = "area-list";

    area.locations.forEach(({ city, state }) => {
      const item = document.createElement("li");
      item.append(document.createTextNode(`${city} `));

      const stateLabel = document.createElement("span");
      stateLabel.className = "area-state";
      stateLabel.textContent = state;

      item.append(stateLabel);
      list.append(item);
    });

    card.append(heading, list);
    return card;
  });

  container.replaceChildren(...cards);
}

export function initializeServiceAreas() {
  document
    .querySelectorAll("[data-service-area-regions]")
    .forEach(renderServiceAreaRegions);
}
